"use client"
import { GetSearchQuery, IPageInfoBlock, IProject } from "apollo"
import { getNonUmbracoUrl } from "./getNonUmbracoUrl"
import type { AISearchItem } from "./searchApi"

function extractTextAndTruncate(maxLength: number, htmlString?: string) {
  if (!htmlString) {
    return ""
  }
  const div = document.createElement("div")
  div.innerHTML = htmlString
  let text = div.textContent || div.innerText || ""

  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "..."
  }
  return text
}

function truncateText(text: string | undefined, maxLength: number): string {
  if (!text) return ""
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "..."
  }
  return text
}

export type SearchResultItem = {
  name: string | undefined
  type: string
  text?: string
  title: string | undefined
  image?: string | undefined
  url: string
}

type Result = SearchResultItem[]
export function extractSearchResults(
  groupId: string[],
  desktop: boolean,
  locale: string,
  data?: GetSearchQuery,
) {
  if (!data) return null
  const projectNodes = data.projects?.nodes ?? []
  const projectsData: Result = projectNodes
    .filter((el) => {
      const properties = el?.namedProperties as IProject
      const projectType = properties.projectType?.value
      const entitledProject = projectType === "זכאים"
      const groups = properties.groupSIte?.contentList ?? []
      return groups.some((group) => groupId.includes(group.key)) && !entitledProject
    })
    .map((el) => {
      const properties = el?.namedProperties as IProject
      desktop ? 95 : 25
      return {
        name: properties.projectTitle?.value as string | undefined,
        type: locale === "en" ? "Project" : "פרויקטים",
        text: extractTextAndTruncate(desktop ? 95 : 25, properties.text?.value as string),
        title: properties.projectTitle?.value as string | undefined,
        image: properties.thumbnailImageForLobbyPage?.mediaItems[0]?.url,
        url: getNonUmbracoUrl(el?.url || ""),
      }
    })

  const pageNodes = data.pages?.nodes ?? []
  const pagesData: Result = pageNodes.map((el) => {
    let type: string = locale === "en" ? "Page" : "דפים"
    if (el?.url?.includes("article")) {
      type = locale === "en" ? "Article" : "כתבות"
    }
    const properties = el?.namedProperties as IPageInfoBlock
    return {
      name: properties.titleBreadcrumbs?.value as string | undefined,
      type,
      title: properties.titleBreadcrumbs?.value as string | undefined,
      url: getNonUmbracoUrl(el?.url || ""),
    }
  })
  const returnArray = [...projectsData, ...pagesData].slice(0, 10)
  return returnArray
}

function extractPathFromUrl(url: string): string {
  try {
    return new URL(url).pathname
  } catch {
    return url
  }
}

export function mapAISearchResults(
  items: AISearchItem[],
  desktop: boolean,
  locale: string,
): SearchResultItem[] {
  return items.slice(0, 10).map((item) => {
    let type: string = locale === "en" ? "Page" : "דפים"
    if (item.path?.includes("/projects/")) {
      type = locale === "en" ? "Project" : "פרויקטים"
    } else if (item.path?.includes("/article")) {
      type = locale === "en" ? "Article" : "כתבות"
    }

    return {
      name: item.name,
      type,
      text: truncateText(item.description, desktop ? 95 : 25),
      title: item.name,
      image: item.imageUrl || undefined,
      url: extractPathFromUrl(item.url),
    }
  })
}
